import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ProjectCardModel} from "../../models/project-card.model";
import {QuickActionMenuModel} from "../../models/quick-action-menu.model";
import {Observable} from "rxjs";
import {environment} from "../../../../../environments/environment";
import { DataManipulationService } from 'src/app/services/data-manipulation.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-quick-actions-menu',
  templateUrl: './quick-actions-menu.component.html',
  styleUrls: ['./quick-actions-menu.component.scss']
})
export class QuickActionsMenuComponent implements OnInit {
  @Input() cardData: ProjectCardModel | undefined;
  @Input() quickActionData!: any;
  @Input() cardPositions: any;

  @Output() emitPauseOrResumeProject = new EventEmitter<any>();
  @Output() emitCloseMenu = new EventEmitter<any>();
  @Output() emitGoToDashboard = new EventEmitter<any>();

  public baseUrl!: string;

  constructor(private data: DataManipulationService, private translate: TranslateService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.baseUrl = environment.baseUrl;
  }

  pauseOrResumeProject(action: string, data: any) {
    this.emitPauseOrResumeProject.emit({action, data});
  }

  removeProjectMemberModal(member: any) {

  }

  copyEmailToClipboard(text: any) {
    navigator.clipboard.writeText(text).then(() => {
      this.data.showAlert(this.translate.instant('copy_email'));
    });
  }

  closeTeamQuickActions() {
    this.emitCloseMenu.emit();
  }

  gotToTeamDashboard() {
    this.emitGoToDashboard.emit()
  }

}
